import {FolderViewDto} from '@shared/modules/library/modules/folders/types/folder-view.dto';

export const getFolderPath = (
    folders: FolderViewDto[],
    targetUuid: string
): FolderViewDto[] => {
    if (!folders.length) return [];
    for (const folder of folders) {
        if (folder.uuid === targetUuid) return [folder];

        if (folder.subFolders && folder.subFolders.length > 0) {
            const foundPath = getFolderPath(folder.subFolders, targetUuid);
            if (foundPath.length > 0) {
                return [folder, ...foundPath];
            }
        }
    }
    return [];
};